(function() { module.exports = window["eventespresso"]["richTextEditor"]; }());